var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "presentation",
    focusable: "false",
    viewBox: "8 8 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__outline",
    d: "M22 9h-7a.5.5 0 1 0 0 1h2.746l-5.077 12H10.5a.5.5 0 1 0 0 1h7a.5.5 0 1 0 0-1h-3.746l5.077-12H22a.5.5 0 1 0 0-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__filled",
    d: "M22 8.5h-7a1 1 0 0 0 0 2h1.991l-4.654 11H10.5a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2h-2.991l4.654-11H22a1 1 0 0 0 0-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.02f22440.svg";
export { ForwardRef as ReactComponent };